import { Link } from "react-router-dom";

const LOGO_SRC = "/clockedin-logo-reverse.webp";

export default function Logo({ light = false, className = "" }) {
  return (
    <Link to="/" data-testid="nav-logo" className={`inline-flex items-center ${className}`}>
      <img
        src={LOGO_SRC}
        alt="ClockedIn HRM"
        width={140}
        height={40}
        className="h-9 w-auto"
        style={light ? { filter: "brightness(0) invert(1)" } : undefined}
      />
    </Link>
  );
}
